import styled from 'styled-components';

const SubscribePopupStyle = styled.section`
	--fixedWidth: var(--sp102x);
	--wrapperBorderRadius: var(--sp2x);
	--wrapperPadTB: var(--sp4x);
	--wrapperPadLR: var(--sp4x);
	--closeSVGSize: var(--sp2x);
	--topGap: var(--sp6x);
	--subscribeBtnMTop: var(--sp5x);

	--largeDistance: var(--sp6x);
	--smallDistance: var(--sp2x);
	--checkboxSize: var(--sp3x);
	--checkboxDistance: var(--sp1-5x);

	position: fixed;
	right: var(--burgerMenuPaddingBottom);
	bottom: var(--burgerMenuPaddingBottom);
	width: var(--fixedWidth);
	isolation: isolate;
	overflow: hidden;
	transform: translateY(120%);
	will-change: transform;
	transition: transform 0.4s ease-out;
	z-index: 99999;

	&.hidden-step {
		transform: translateY(120%) !important;
	}

	&.is-first {
		transform: translateY(0);
	}

	&.step-2 {
		.subscribe-btn-block {
			margin-top: var(--largeDistance);
		}
	}

	.subscribe-inner-wrapper {
		width: 100%;
		border-radius: var(--wrapperBorderRadius);
		background-color: var(--mainColor);
		padding: var(--wrapperPadTB) var(--wrapperPadLR);
		position: relative;
		overflow: hidden;

		&:before {
			content: '';
			position: absolute;
			top: -10%;
			left: -10%;
			width: 120%;
			height: 120%;
			background-color: var(--mainColor);
			z-index: -1;
		}
	}

	.subscribe-discount-text {
		color: var(--neutral900);
	}

	.top-wrapper {
		display: flex;
		justify-content: space-between;
		gap: var(--topGap);
	}

	.svg-block {
		flex-shrink: 0;
		display: flex;
		max-width: var(--closeSVGSize);
		width: 100%;
		height: fit-content;
		cursor: pointer;
	}

	svg {
		height: var(--closeSVGSize);

		path {
			transition: fill var(--trTime) ease-out;
		}

		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover {
					path {
						fill: var(--neutral1000);
					}
				}
			}
		}
	}

	.subscribe-btn-block {
		margin-top: var(--subscribeBtnMTop);
	}

	.extra-class {
		color: var(--pink1000);
	}

	.subscribe-privacy-policy-text {
		color: var(--neutral1000);
		margin-top: var(--largeDistance);
	}

	.step-2-wrapper {
		margin-top: var(--largeDistance);
	}

	.form-item {
		&:not(:first-child) {
			margin-top: var(--smallDistance);
		}
	}

	.form-item-label {
		label {
			font-size: var(--p5);
			line-height: var(--lineHeight);
			font-weight: 500;
		}
	}

	.custom-checkbox-container {
		--account_checkboxMarTopSize: var(--smallDistance);
	}

	.custom-checkbox-wrap {
		--account_checkboxWrapSize: var(--checkboxSize);
		--account_checkboxWrapDistance: var(--checkboxDistance);
	}

	.checkbox-text {
		font-size: var(--p5);
		line-height: var(--lineHeight);
		font-family: var(--montserrat_arm);
		font-weight: 500;
		color: var(--neutral1000);
	}

	.subscribe-success-description {
		margin-top: var(--smallDistance);
		color: var(--neutral900);
	}

	.privacy-link {
		text-decoration: underline;

		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover {
					text-decoration: none;
				}
			}
		}
	}

	&.hide {
		display: none;
		pointer-events: none;
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--fixedWidth: var(--sp82x);
		--wrapperBorderRadius: var(--sp2x);
		--wrapperPadTB: var(--sp3x);
		--wrapperPadLR: var(--sp3x);
		--closeSVGSize: 14px;
		--topGap: var(--sp4x);
		--subscribeBtnMTop: var(--sp4x);

		--largeDistance: var(--sp5x);
		--smallDistance: var(--sp2x);
		--checkboxSize: var(--sp3x);
		--checkboxDistance: var(--sp1x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--fixedWidth: var(--sp67x);
		--wrapperBorderRadius: var(--sp2x);
		--wrapperPadTB: var(--sp3x);
		--wrapperPadLR: var(--sp3x);
		--closeSVGSize: 14px;
		--topGap: var(--sp3x);
		--subscribeBtnMTop: var(--sp4x);

		--largeDistance: var(--sp4x);
		--smallDistance: var(--sp2x);
		--checkboxSize: var(--sp3x);
		--checkboxDistance: var(--sp1x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--fixedWidth: var(--sp62x);
		--wrapperBorderRadius: var(--sp1-5x);
		--wrapperPadTB: var(--sp2-5x);
		--wrapperPadLR: var(--sp2-5x);
		--closeSVGSize: 14px;
		--topGap: var(--sp3x);
		--subscribeBtnMTop: var(--sp3x);

		--largeDistance: var(--sp4x);
		--smallDistance: var(--sp1-5x);
		--checkboxSize: var(--sp2x);
		--checkboxDistance: var(--sp1x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--fixedWidth: var(--sp59x);
		--wrapperBorderRadius: var(--sp1-5x);
		--wrapperPadTB: var(--sp2x);
		--wrapperPadLR: var(--sp2x);
		--closeSVGSize: 14px;
		--topGap: var(--sp3x);
		--subscribeBtnMTop: var(--sp2-5x);

		--largeDistance: var(--sp3x);
		--smallDistance: var(--sp1-5x);
		--checkboxSize: var(--sp2x);
		--checkboxDistance: var(--sp1x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--fixedWidth: var(--sp43x);
		--wrapperBorderRadius: var(--sp1x);
		--wrapperPadTB: var(--sp1-5x);
		--wrapperPadLR: var(--sp1-5x);
		--closeSVGSize: var(--sp1-5x);
		--topGap: var(--sp3x);
		--subscribeBtnMTop: var(--sp2x);

		--largeDistance: var(--sp2x);
		--smallDistance: var(--sp1-5x);
		--checkboxSize: var(--sp2x);
		--checkboxDistance: var(--sp1x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--fixedWidth: calc(100% - var(--burgerMenuPaddingBottom) * 2);
		--wrapperBorderRadius: var(--sp1x);
		--wrapperPadTB: var(--sp1-5x);
		--wrapperPadLR: var(--sp1-5x);
		--closeSVGSize: var(--sp1-5x);
		--topGap: var(--sp3x);
		--subscribeBtnMTop: var(--sp2x);

		--largeDistance: var(--sp2x);
		--smallDistance: var(--sp1-5x);
		--checkboxSize: var(--sp2x);
		--checkboxDistance: var(--sp1x);
	}
`;

export default SubscribePopupStyle;
